module.exports = __webpack_public_path__ + "img/dole-whip-lemonade.82e6cb80.jpg";